import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FetchParticipantsListModel} from "../models/fetch-participants-list.model";
import {v1URL} from "../../../shared/constants/urls.constants";
import {CommonService} from "../../../shared/services/common.service";
import {FetchParticipantInformationModel} from "../models/fetch-participant-information.model";
import {FetchRelationshipQuestionModel} from "../models/fetch-relationship-question.model";
import {FetchRelationsFilterModel} from "../models/fetch-relations-filter.model";
import {QuestionResponse} from "../../../../models/question-response";
import {SaveAnswersModel} from "../models/save-answers.model";
import {UpdateRelationModel} from "../models/update-relation.model";
import {MarkHipaaConsentModel} from "../models/mark-hipaa-consent.model";
import {EditProfileModel} from "../../../shared/models/edit-profile.model";

@Injectable({
  providedIn: 'root',
})
export class ParticipantsListService {
  constructor(
    private commonServices: CommonService
  ) {
  }

  fetchParticipantsList(payload): Observable<FetchParticipantsListModel['response']> {
    const urlConfig = v1URL.participants
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchParticipantInformation(payload: FetchParticipantInformationModel['request']): Observable<FetchParticipantInformationModel['response']> {
    const urlConfig = v1URL.user.profile.fetch;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload), payload);
  }

  fetchObQuestions(payload: FetchRelationshipQuestionModel['request']): Observable<FetchRelationshipQuestionModel['response']> {
    const urlConfig = v1URL.user["ob-questions"]["ob-questions"]
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchRelationsFilter(): Observable<FetchRelationsFilterModel['response']> {
    const urlConfig = v1URL.filters.relations
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  saveAnswers(payload?: { responses?: QuestionResponse[] }): Observable<SaveAnswersModel["response"]> {
    const urlConfig = v1URL.user['ob-questions']['save-responses']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  updateRelation(payload: UpdateRelationModel['request']): Observable<UpdateRelationModel["response"]> {
    const urlConfig = v1URL.user.registration['update-relation']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  markHipaaConsent(payload): Observable<MarkHipaaConsentModel["response"]> {
    const urlConfig = v1URL.user.registration['sign-hipaa-consent']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  editProfile(payload): Observable<EditProfileModel["response"]> {
    const urlConfig = v1URL.user.profile.edit
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

}
